/**
 * Focus tools.
 */
H_Tools.focus = (() => {
    // console.log('Focus tools initialized');

    /**
     * Finds and returns all focusable children of the supplied element.
     *
     * @param {*} element An element
     * @returns           An array of focusable elements
     */
    function getFocusableChildren(element) {
        if (!element) {
            return [];
        }
        return element.querySelectorAll([
            'input',
            'select',
            'a[href]',
            'textarea',
            'button',
            '[tabindex]',
        ]);
    }

    // Return an object to expose inner functions
    return {
        getFocusableChildren: getFocusableChildren,
    };
})();
